import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Main from "./accueil";
import Contact from "./contact";
import Footer from "./FOOTER";
import Links from "./links";
import {
  NordDuMaroc,
  MarocMediterranee,
  CentreAtlantiqueMaroc,
  CentreDuMaroc,
  AtlasDuMaroc,
  SudDuMaroc,
  AfriqueDuNord,
  Afrique,
  MoyenOrient,
  Europe,
  Asie,
  SouthAmerica,
  Hadj,
  Omrah,
} from "./dest";
import { BookingOmrah } from "./bookings";
import { BookingOmrahfr } from "./bookings";
import { BookingOmrah1 } from "./bookings";
import { BookingOmrahRamadan1 } from "./bookings";
import { BookingOmrahRamadan11 } from "./bookings";
// import { BookingOmrahChr } from "./bookings";
// import { BookingOmrahChaa } from "./bookings";
// import {BookingOmrahChaw} from "./bookings";
// import Offres from "./offres";
import { BookingVisa1 } from "./bookings";
import { OMDUBAI } from "./bookings";
import { Flights } from "./bookings";
import { Cruises } from "./bookings";

function AppRouter() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/Nord_du_Maroc" element={<NordDuMaroc />} />
        <Route path="/Maroc-mediterranee" element={<MarocMediterranee />} />
        <Route
          path="/Centre-atlantique-du-Maroc"
          element={<CentreAtlantiqueMaroc />}
        />
        <Route path="/Centre_du_Maroc" element={<CentreDuMaroc />} />
        <Route path="/Atlas_du_Maroc" element={<AtlasDuMaroc />} />
        <Route path="/Sud_du_Maroc" element={<SudDuMaroc />} />
        <Route path="/Afrique-du-nord" element={<AfriqueDuNord />} />
        <Route path="/Afrique" element={<Afrique />} />
        <Route path="/Moyen-orient" element={<MoyenOrient />} />
        <Route path="/Europe" element={<Europe />} />
        <Route path="/Asie" element={<Asie />} />
        <Route path="/South-America" element={<SouthAmerica />} />
        <Route path="/Hadj" element={<Hadj />} />
        <Route path="/Omrah" element={<Omrah />} />
        <Route path="/booking-omrah" element={<BookingOmrah />} />
        <Route path="/booking-omrahRamadan1" element={<BookingOmrahRamadan1 />} />
        <Route path="/booking-omrahRamadan11" element={<BookingOmrahRamadan11 />} />
        <Route path="/booking-omrah-1446" element={<BookingOmrah1 />} />
        <Route path="/OMDUBAI" element={<OMDUBAI />} />
        <Route path="/FLIGHTS" element={<Flights />} />
        <Route path="/CRUISES" element={<Cruises />} />
        <Route path="/Visa1" element={<BookingVisa1 />} />
        <Route path="/booking-omrah-finRamadan" element={<BookingOmrahfr />} />
        {/* <Route path="/booking-omrah-ChaabanRamadan" element={<BookingOmrahChr />}/>
        <Route path="/booking-omrah-Chaaban" element={<BookingOmrahChaa />} /> */}
        {/* <Route path="/booking-omrahChawwal" element={<BookingOmrahChaw/>} /> */}
        <Route path="/Links" element={<Links/>} />

      </Routes>
      <Footer />
    </Router>
  );
}

export default AppRouter;
